import React, { useRef, useEffect } from 'react';
import { Copy, Trash2, Undo2 } from 'lucide-react';

const MessageContextMenu = ({ 
  isOpen, 
  position, 
  onClose, 
  onCopy, 
  onDelete, 
  onRecall, 
  canRecall,
  isRecalled 
}) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen || isRecalled) return null;

  const menuItems = [
    { 
      icon: Copy, 
      label: '复制', 
      onClick: () => { onCopy(); onClose(); },
      color: 'text-white'
    },
    ...(canRecall ? [{ 
      icon: Undo2, 
      label: '撤回', 
      onClick: () => { onRecall(); onClose(); },
      color: 'text-yellow-400'
    }] : []),
    { 
      icon: Trash2, 
      label: '删除', 
      onClick: () => { onDelete(); onClose(); },
      color: 'text-red-400'
    }
  ];

  return (
    <div
      ref={menuRef}
      className="fixed z-[100] glass-card rounded-xl overflow-hidden shadow-2xl border border-white/10"
      style={{
        left: position.x,
        top: position.y,
        transform: 'translate(-50%, -100%)',
        marginTop: '-8px'
      }}
    >
      {menuItems.map((item, index) => (
        <button
          key={index}
          onClick={item.onClick}
          className="flex items-center gap-3 w-full px-4 py-3 hover:bg-white/10 transition-colors"
        >
          <item.icon size={18} className={item.color} />
          <span className={`text-sm font-medium ${item.color}`}>{item.label}</span>
        </button>
      ))}
    </div>
  );
};

export default MessageContextMenu;
